// extracted by mini-css-extract-plugin
export default {"adjacentVendors":"adjacentVendors__OTAyN","adjacentVendorCard":"adjacentVendorCard__MGE1N"};